import { useShareableLocation } from '@/hooks/useShareableLocation';
import { ShareControl } from './ShareControl';
import { SharedLocationMarker } from './SharedLocationMarker';
import { SharedLocationCard } from './SharedLocationCard';

/**
 * Single mount point for the shareable-location feature. Wire this in once
 * (inside MapContainer, under the map) and it handles everything:
 *
 *  - useShareableLocation(): on-load restore from the URL (`?ll=` pin /
 *    `#map=` view) + keeping the `#map=` hash in sync as the user pans/zooms.
 *  - <SharedLocationMarker/>: drops the pin marker for a shared point.
 *  - <SharedLocationCard/>: the "shared location" card with a Directions action.
 *  - <ShareControl/>: the floating Share button + copy popover.
 */
export function ShareLayer() {
  useShareableLocation();

  return (
    <>
      <SharedLocationMarker />
      <SharedLocationCard />
      <ShareControl />
    </>
  );
}
